export default {
    h1: 'Join us',
    h2: 'Become part of AirClass!',
    p: `Build the world's first ranked school`,
    flexible: 'Flexible',
    ful: 'Fulfilling',
    high: 'High Salary',
    apply: 'Apply Now',
    dialog: 'Please send your resume to this Email：',
    copy: 'Copy',
}